import { Text } from '@farmersdog/corgi-x';

import { SpanRenderer } from './SpanRenderer';
import styles from './TextTypeRenderer.css';
import { TextNodeType } from './types';

import type { TextNode } from './types';

export interface TextTypeRendererProp {
  nodes: TextNode[];
}

export function TextTypeRenderer({ nodes }: TextTypeRendererProp) {
  return (
    <>
      {nodes.map((node, key) => {
        const { type, spans, text } = node;

        switch (type) {
          case TextNodeType.paragraph: {
            return (
              <Text
                key={key}
                as="p"
                variant="article-20"
                color="charcoal-3"
                className={styles.paragraph}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading1: {
            return (
              <Text
                key={key}
                as="h1"
                variant="heading-52"
                color="kale-3"
                className={styles.h1}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading2: {
            return (
              <Text
                key={key}
                as="h2"
                variant="heading-40"
                color="kale-3"
                className={styles.h2}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading3: {
            return (
              <Text
                key={key}
                as="h3"
                variant="heading-28"
                color="kale-3"
                className={styles.h3}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading4: {
            return (
              <Text
                key={key}
                as="h4"
                variant="heading-22"
                color="kale-3"
                className={styles.h4}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading5: {
            return (
              <Text
                key={key}
                as="h5"
                variant="heading-20"
                color="kale-3"
                className={styles.h5}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }

          case TextNodeType.heading6: {
            return (
              <Text
                key={key}
                as="h6"
                variant="heading-16"
                color="kale-3"
                className={styles.h6}
              >
                <SpanRenderer spans={spans} text={text} />
              </Text>
            );
          }
        }
      })}
    </>
  );
}
